<template>
  <div :style="{ width: '100%', height: '100%' }" v-loading="isLoading">
    <template v-if="rfqID && salesOrderID" >
      <slot :rfqID="rfqID" />
    </template>
  </div>
</template>

<script>
import { ServiceSalesOrders } from '@/services/SalesOrders'

export default {
  name: 'DataProvider',
  props: {
    editorID: {
      type: String,
      required: true
    },
    salesOrderID: {
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      rfqID: null
    }
  },
  watch: {
    salesOrderID: {
      immediate: true,
      handler (v) {
        if (v) {
          this.loadRfqID()
        }
      }
    },
    rfqID: {
      immediate: true,
      handler (v) {
        let query = Object.assign({}, this.$route.query, { [this.editorID]: `edit[${v}]` })
        if (!v) {
          query = Object.assign({}, this.$route.query)
          delete query[this.editorID]
        }
        this.$router.replace({ ...this.$router.currentRoute, query })
      }
    }
  },
  methods: {
    async loadRfqID () {
      this.isLoading = true

      try {
        const { data } = await ServiceSalesOrders
          .getDynamic(this.salesOrderID, { select: 'rfq.id as rfqID' })

        this.rfqID = data.rfqID
      } catch (e) {
        this.requestErrorHandler(e, e.message)
        this.rfqID = null
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
